import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, LocalService, NumericConfig, Status, TriggeredEvent, Wrapper5 } from '../../../service/local.service';

@Component({
  selector: 'app-general-configuration-popup',
  templateUrl: './general-configuration-popup.component.html',
  styleUrls: ['./general-configuration-popup.component.scss']
})
export class GeneralConfigurationPopupComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["general_config"];
  wrapper: Wrapper5; isLargeText = false; message: string = ''; isRedAlert: boolean = true;
  id: string; configType: number = null; ctryCode: string = ''; maxBodyHeight = 0;
  numericConfig: NumericConfig = { isStartWithZeroAllowed: true } as NumericConfig;

  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    if (this.configType != null) {
      this.isLargeText = this.configType == 9;
    }
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.wrapper = {
        content: { key: '', v1: this.configType.toString(), v2: null, v3: '', v4: '', v5: '' } as KeyValues5
      } as Wrapper5;
    }
    else {
      this.configurationManagementService.getConfiguration(this.id).subscribe(result => {
        this.wrapper = result;
      });
    }
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.wrapper.content.v4 = this.ctryCode;
      this.configurationManagementService.saveGeneralConfiguration(this.wrapper).subscribe(result => {
        if (result.status == Status.Success) {
          this.wrapper.content.key = this.id == '' ? result.id : this.id;
          this.wrapper.content.v3 = this.wrapper.languageContents.find(x => x.v1 == this.localService.selected.applicationLanguage).v3;
          this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
        }
      });
    }
  }

  onEmptyLanguageContainerAdded(languageContents: any) {
    this.wrapper.languageContents = languageContents;
  }

  doCheck() {
    this.message = '';
    this.isRedAlert = false;
    // if (this.localService.getLoginAsCountryCode()  != '' && this.wrapper.content.v3 == '') {
    //   this.message = this.localService.languageContent.general_config.need_code;
    // }
    this.isRedAlert = this.message != '';
    return this.message == '';
  }
}
